module.exports = __webpack_public_path__ + "img/icon-singpass.d5ca120a.svg";